import { jsx as _jsx } from "react/jsx-runtime";
import { motion } from 'framer-motion';
import { forwardRef } from 'react';
import { brand } from '@iheart/shared';
import { cn } from './cn.js';
/**
 * Branded anchor with the same 5px-grow motion as MotionButton. Use for
 * inline CTAs and nav links so motion is consistent across the app.
 */
export const MotionLink = forwardRef(function MotionLink({ underline = false, className, children, ...rest }, ref) {
    return (_jsx(motion.a, { ref: ref, whileHover: { scale: brand.motion.grow }, whileTap: { scale: brand.motion.grow }, transition: brand.motion.spring, className: cn('inline-flex items-center gap-1 font-medium text-pink-600 transition-colors hover:text-pink-700', underline && 'underline underline-offset-4', className), ...rest, children: children }));
});
//# sourceMappingURL=MotionLink.js.map